import { Alert, AlertTitle } from '@mui/material'
import { IPageAlert } from './@types'

export function PageAlert({ alertName, alertMessage, ...props }: IPageAlert) {
  return (
    <Alert sx={props.sx} {...props}>
      <AlertTitle color="white">{alertName}</AlertTitle>
      {alertMessage && <div className="mt-4">{alertMessage}</div>}
    </Alert>
  )
}
